/** A word written as a title-case word: one capital followed only by lowercase letters ("Collaborator", not "AI" or "iCloud") */
const titleCaseWord = /^[A-Z][a-z]+$/

/**
 * Sentence case for a display name written in Title Case: "Songwriting Collaborator" → "Songwriting collaborator".
 * The first word is kept as written, and acronyms and mixed-case words ("MIDI", "iCloud") are left alone.
 */
export const sentenceCase = (text: string) =>
  text
    .split(' ')
    .map((word, idx) => (idx > 0 && titleCaseWord.test(word) ? word.toLowerCase() : word))
    .join(' ')
